module.exports = __webpack_public_path__ + "static/media/email-icon.f4d9ad87.svg";